export default function CVList() {
    return null;
}